/**
 * @param {Env} env
 * @param {Settings} settings
 * @param {Snippet} snippet
 * @param {Customization} customization
 * @constructor
 */
export let AppConfig = function (env, settings, snippet, customization) {
  /**
   *
   */
  this.init = () => {
    settings.init();
    this.customization().onConfigReady(this);
  };

  /**
   * @return {Env}
   */
  this.env = () => env;

  /**
   * @return {Settings}
   */
  this.settings = () => settings;

  /**
   * @return {Snippet}
   */
  this.snippet = () => snippet;

  /**
   * @return {Customization}
   */
  this.customization = () => customization;

  /*******************************************/

  /**
   * @return {{}}
   */
  this.getCustomer = () => this.snippet().customer;

  /**
   * @return {boolean}
   */
  this.isCampaignEnabled = () => this.settings().shop.active;

  /**
   * @return {boolean}
   */
  this.isBarOn = () => this.isCampaignEnabled() && this.settings().shop.shopfront.params.bar.active;

  /**
   * @return {boolean}
   */
  this.isBadgeOn = () => this.isCampaignEnabled() && this.settings().shop.shopfront.params.badge.active;

  /**
   * @return {boolean}
   */
  this.isRedeemOn = () => this.getCustomer().id && this.isCampaignEnabled();

  /**
   *
   * @param page:string
   * @return {boolean}
   */
  this.isCustomerAccountOn = (page) => page === 'account' && this.isCampaignEnabled();
  /**
   * @return {{bar, badge, widget, popup_pages}}
   */
  this.getTexts = () => this.settings().shop.shopfront.settings_text;

  /**
   * @return {boolean}
   */
  this.isPurchasesActive = () => this.isCampaignEnabled() && this.settings().shop.rewards.purchase.active;

  /**
   * @return {[{product_id: int}]}
   */
  this.getTargetProducts = () => this.settings().products;

  /**
   * @return {{position, selector}}
   */
  this.getRedeemSelector = () => this.settings().shop.shopfront.selectors.redeem;

  /**
   * @return {{position, selector}}
   */
  this.getWidgetSelector = () => this.settings().shop.shopfront.selectors.points_info;

  /**
   * @return {number}
   */
  this.getPurchaseRate = () => parseFloat(this.settings().shop.rewards.purchase.amount);

  /**
   * @return {number}
   */
  this.getRedeemRate = () => this.settings().shop.spend_rate;

  /**
   * @return {number}
   */
  this.getMinSubTotal = () => {
    return this.settings().shop.spendLimit.min_subtotal_active
        ? this.settings().shop.spendLimit.min_subtotal
        : 0;
  }

  /**
   * @return {number}
   */
  this.getMaxPointsPart = () => {
    return this.settings().shop.spendLimit.max_points_part_active
        ? this.settings().shop.spendLimit.max_points_part
        : 100;
  }

  /**
   * @return {string} type of widget's points info
   */
  this.getInfoType = () => this.settings().shop.shopfront.params.points_info.type[0]; // todo: Какого хера здесь [0] ??

  /**
   * @return {{position, selector}}
   */
  this.getCartTotalSelector = () => this.settings().shop.shopfront.selectors.cart_total;

  /**
   * @return {{purchase, share, referral, register, visits, dob}}
   */
  this.getRewardsRates = () => this.settings().shop.rewards;

  /**
   * @return {string}
   */
  this.getBadgePosition = () => this.settings().shop.shopfront.params.badge.position;

  /**
   * @return {string}
   */
  this.getBarPosition = () => this.settings().shop.shopfront.params.bar.position;

  /**
   * @return {{google_plus, twitter, facebook, pinterest}}
   */
  this.getSocials = () => this.settings().shop.rewards.share.params;

  /**
   * @return {{applied: string}}
   */
  this.getCookieNames = () => {
    return {applied: 'applied_points'};
  };

  /**
   *
   * @returns {{redeemed: string, historyAllTime: string, available: string, tabHistoryEmpty: string, historyShow: string, numberPoints: string, visits_customer: string, historyDate: string, terms: string, historyType: string, tabHistoryChargeExpired: string, termsContent: string, historySortBy: string, copyLink: string, copiedLink: string, info: string, earningPoints: string, currentPointsBalance: string, forEach: string, purchase: string, history: string, youCanEarn: string, social_sharing: string, btnApply: string, singUp: string, referral: string, historyDays: string, didntEarnPoint: string, btnReset: string, tabHistoryChargePurchase: string, tabHistoryOrderCancel: string, manualEditing: string, register: string}}
   */
  this.getPopupText = () => {
    return {
      earningPoints: this.settings().shop.shopfront.settings_text.popup_pages.text.earningPoints,
      numberPoints: this.settings().shop.shopfront.settings_text.popup_pages.text.numberPoints,
      available: this.settings().shop.shopfront.settings_text.popup_pages.text.available,
      copyLink: this.settings().shop.shopfront.settings_text.popup_pages.text.copyLink,
      copiedLink: this.settings().shop.shopfront.settings_text.popup_pages.text.copiedLink,
      forEach: this.settings().shop.shopfront.settings_text.popup_pages.text.forEach,
      history: this.settings().shop.shopfront.settings_text.popup_pages.text.history,
      info: this.settings().shop.shopfront.settings_text.popup_pages.text.info,
      purchase: this.settings().shop.shopfront.settings_text.popup_pages.text.purchase,
      redeemed: this.settings().shop.shopfront.settings_text.popup_pages.text.redeemed,
      referral: this.settings().shop.shopfront.settings_text.popup_pages.text.referral,
      register: this.settings().shop.shopfront.settings_text.popup_pages.text.register,
      singUp: this.settings().shop.shopfront.settings_text.popup_pages.text.singUp,
      social_sharing: this.settings().shop.shopfront.settings_text.popup_pages.text.social_sharing,
      terms: this.settings().shop.shopfront.settings_text.popup_pages.text.terms,
      termsContent: this.getTermsText(),
      visits_customer: this.settings().shop.shopfront.settings_text.popup_pages.text.visits_customer,
      youCanEarn: this.settings().shop.shopfront.settings_text.popup_pages.text.youCanEarn,
      currentPointsBalance: this.settings().shop.shopfront.settings_text.popup_pages.text.currentPointsBalance,
      historySortBy: this.settings().shop.shopfront.settings_text.popup_pages.text.historySortBy,
      historyType: this.settings().shop.shopfront.settings_text.popup_pages.text.historyType,
      historyDate: this.settings().shop.shopfront.settings_text.popup_pages.text.historyDate,
      historyShow: this.settings().shop.shopfront.settings_text.popup_pages.text.historyShow,
      historyAllTime: this.settings().shop.shopfront.settings_text.popup_pages.text.historyAllTime,
      historyDays: this.settings().shop.shopfront.settings_text.popup_pages.text.historyDays,
      didntEarnPoint: this.settings().shop.shopfront.settings_text.popup_pages.text.didntEarnPoint,
      tabHistoryEmpty: this.settings().shop.shopfront.settings_text.popup_pages.text.tabHistoryEmpty,
      tabHistoryChargeExpired: this.settings().shop.shopfront.settings_text.popup_pages.text.tabHistoryChargeExpired,
      tabHistoryChargePurchase: this.settings().shop.shopfront.settings_text.popup_pages.text.tabHistoryChargePurchase,
      tabHistoryOrderCancel: this.settings().shop.shopfront.settings_text.popup_pages.text.tabHistoryOrderCancel,
      manualEditing: this.settings().shop.shopfront.settings_text.popup_pages.text.manualEditing,
      btnApply: this.settings().shop.shopfront.settings_text.redeem_text.btnApply,
      btnReset: this.settings().shop.shopfront.settings_text.redeem_text.btnReset
    }
  };
  /**
   * @return {{singular: string, plural: string}}
   */
  this.getPointNames = () => {
    return {
      singular: this.settings().shop.point_name_singular,
      plural: this.settings().shop.point_name_plural
    };
  };


  /**
   *
   * @return {string|string}
   */
  this.getTermsText = () => {
    let params = {
      spend_rate: '{{&spend_rate}}',
      plural: this.settings().shop.point_name_plural,
      singular: this.settings().shop.point_name_singular,
      currency: Spurit.globalSnippet.shop_currency,
      min_subtotal: '{{&min_subtotal}}',
      max_points_part: this.getMaxPointsPart()
    };
    let string = this.settings().shop.shopfront.settings_text.popup_pages.text.termsContent;

    for (let key in params) {
      string = string.replaceAll(`[${key}]`, `<strong>${params[key]}</strong>`);
    }
    string = string.replaceAll('\\n', '<br />');
    string = string.replaceAll('\n', '<br />');

    return string;
  };

  /**
   *
   * @return {{visits: string, referral: string, dob: string, purchase: string, share: string, manual: string, register: string}}
   */
  this.rewardNames = () => {
    return {
      purchase: this.settings().shop.shopfront.settings_text.popup_pages.text.purchase,
      share: this.settings().shop.shopfront.settings_text.popup_pages.text.social_sharing,
      referral: this.settings().shop.shopfront.settings_text.popup_pages.text.referral,
      register: this.settings().shop.shopfront.settings_text.popup_pages.text.register,
      visits: this.settings().shop.shopfront.settings_text.popup_pages.text.visits_customer,
      dob: '',
      manual: this.settings().shop.shopfront.settings_text.popup_pages.text.manualEditing,
      order_cancel: this.settings().shop.shopfront.settings_text.popup_pages.text.tabHistoryOrderCancel
    };
  };

  /**
   * @return {{google_plus: string, twitter: string, facebook: string, pinterest: string}}
   */
  this.socialNames = () => {
    return {
      google_plus: 'Google+',
      twitter: 'Twitter',
      facebook: 'Facebook',
      pinterest: 'Pinterest',
      instagram: 'Instagram',
    };
  };

  /**
   * @return {{google_plus: string, twitter: string, facebook: string, pinterest: string}}
   */
  this.socialIcons = () => {
    return {
      google_plus: '<svg enable-background="new 0 0 128 128" height="35" id="svg_resize" version="1.1" viewBox="0 0 128 128" width="35" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g><circle cx="64" cy="64" fill="#D95032" r="64"></circle><g><g><path d="M49.424,97.875c-19.018,0-34.491-15.193-34.491-33.874c0-18.68,15.473-33.875,34.491-33.875     c8.318,0,16.354,2.952,22.624,8.309l-8.771,9.899c-3.838-3.279-8.758-5.086-13.853-5.086c-11.652,0-21.13,9.31-21.13,20.752     c0,11.441,9.479,20.75,21.13,20.75c9.858,0,16.311-4.723,18.407-13.197H49.587V58.432h32.347v6.562     C81.934,84.659,68.869,97.875,49.424,97.875z" fill="#FFFFFF"></path></g><polygon fill="#FFFFFF" points="117.934,58.438 107.934,58.438 107.934,48.438 99.934,48.438 99.934,58.438 89.934,58.438     89.934,66.438 99.934,66.438 99.934,76.438 107.934,76.438 107.934,66.438 117.934,66.438   "></polygon></g></g></svg>',
      twitter: '<svg enable-background="new 0 0 56.693 56.693" height="40" id="svg_resize" version="1.1" viewBox="0 0 56.693 56.693" width="40" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M28.348,5.157c-13.6,0-24.625,11.027-24.625,24.625c0,13.6,11.025,24.623,24.625,24.623c13.6,0,24.623-11.023,24.623-24.623  C52.971,16.184,41.947,5.157,28.348,5.157z M40.752,24.817c0.013,0.266,0.018,0.533,0.018,0.803c0,8.201-6.242,17.656-17.656,17.656  c-3.504,0-6.767-1.027-9.513-2.787c0.486,0.057,0.979,0.086,1.48,0.086c2.908,0,5.584-0.992,7.707-2.656  c-2.715-0.051-5.006-1.846-5.796-4.311c0.378,0.074,0.767,0.111,1.167,0.111c0.566,0,1.114-0.074,1.635-0.217  c-2.84-0.57-4.979-3.08-4.979-6.084c0-0.027,0-0.053,0.001-0.08c0.836,0.465,1.793,0.744,2.811,0.777  c-1.666-1.115-2.761-3.012-2.761-5.166c0-1.137,0.306-2.204,0.84-3.12c3.061,3.754,7.634,6.225,12.792,6.483  c-0.106-0.453-0.161-0.928-0.161-1.414c0-3.426,2.778-6.205,6.206-6.205c1.785,0,3.397,0.754,4.529,1.959  c1.414-0.277,2.742-0.795,3.941-1.506c-0.465,1.45-1.448,2.666-2.73,3.433c1.257-0.15,2.453-0.484,3.565-0.977  C43.018,22.849,41.965,23.942,40.752,24.817z" fill="#40ced7"></path></svg>',
      pinterest: '<svg enable-background="new 0 0 56.693 56.693" height="40" id="svg_resize" version="1.1" viewBox="0 0 56.693 56.693" width="40" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g><path d="M28.348,5.158c-13.599,0-24.625,11.023-24.625,24.625c0,10.082,6.063,18.744,14.739,22.553   c-0.069-1.721-0.012-3.783,0.429-5.654c0.473-2,3.168-13.418,3.168-13.418s-0.787-1.572-0.787-3.896   c0-3.648,2.115-6.373,4.749-6.373c2.24,0,3.322,1.682,3.322,3.695c0,2.252-1.437,5.619-2.175,8.738   c-0.616,2.613,1.31,4.744,3.887,4.744c4.665,0,7.808-5.992,7.808-13.092c0-5.397-3.635-9.437-10.246-9.437   c-7.47,0-12.123,5.57-12.123,11.792c0,2.146,0.633,3.658,1.624,4.83c0.455,0.537,0.519,0.754,0.354,1.371   c-0.118,0.453-0.389,1.545-0.501,1.977c-0.164,0.625-0.669,0.848-1.233,0.617c-3.44-1.404-5.043-5.172-5.043-9.408   c0-6.994,5.899-15.382,17.599-15.382c9.4,0,15.588,6.804,15.588,14.107c0,9.658-5.369,16.875-13.285,16.875   c-2.659,0-5.16-1.438-6.016-3.068c0,0-1.43,5.674-1.732,6.768c-0.522,1.9-1.545,3.797-2.479,5.275   c2.215,0.654,4.554,1.01,6.979,1.01c13.598,0,24.623-11.023,24.623-24.623C52.971,16.181,41.945,5.158,28.348,5.158z" fill="#bb2226"></path></g></svg>',
      facebook: '<svg enable-background="new 0 0 56.693 56.693" height="40" id="svg_resize" version="1.1" viewBox="0 0 56.693 56.693" width="40" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M28.347,5.157c-13.6,0-24.625,11.027-24.625,24.625c0,13.6,11.025,24.623,24.625,24.623c13.6,0,24.625-11.023,24.625-24.623  C52.972,16.184,41.946,5.157,28.347,5.157z M34.864,29.679h-4.264c0,6.814,0,15.207,0,15.207h-6.32c0,0,0-8.307,0-15.207h-3.006  V24.31h3.006v-3.479c0-2.49,1.182-6.377,6.379-6.377l4.68,0.018v5.215c0,0-2.846,0-3.398,0c-0.555,0-1.34,0.277-1.34,1.461v3.163  h4.818L34.864,29.679z" fill="#3f67a9"></path></svg>',
      instagram: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" width="40px" height="36px" viewBox="0 0 49.652 49.652" xml:space="preserve"><path d="M24.825,29.796c2.739,0,4.972-2.229,4.972-4.97c0-1.082-0.354-2.081-0.94-2.897c-0.903-1.252-2.371-2.073-4.029-2.073     c-1.659,0-3.126,0.82-4.031,2.072c-0.588,0.816-0.939,1.815-0.94,2.897C19.854,27.566,22.085,29.796,24.825,29.796z" fill="#bd00a0"/><polygon points="35.678,18.746 35.678,14.58 35.678,13.96 35.055,13.962 30.891,13.975 30.907,18.762    " fill="#bd00a0"/><path d="M24.826,0C11.137,0,0,11.137,0,24.826c0,13.688,11.137,24.826,24.826,24.826c13.688,0,24.826-11.138,24.826-24.826     C49.652,11.137,38.516,0,24.826,0z M38.945,21.929v11.56c0,3.011-2.448,5.458-5.457,5.458H16.164     c-3.01,0-5.457-2.447-5.457-5.458v-11.56v-5.764c0-3.01,2.447-5.457,5.457-5.457h17.323c3.01,0,5.458,2.447,5.458,5.457V21.929z" fill="#bd00a0"/><path d="M32.549,24.826c0,4.257-3.464,7.723-7.723,7.723c-4.259,0-7.722-3.466-7.722-7.723c0-1.024,0.204-2.003,0.568-2.897     h-4.215v11.56c0,1.494,1.213,2.704,2.706,2.704h17.323c1.491,0,2.706-1.21,2.706-2.704v-11.56h-4.217     C32.342,22.823,32.549,23.802,32.549,24.826z" fill="#bd00a0"/></svg>',
    };
  };

  /**
   * @param {int} pointsAmount
   * @return {string}
   */
  this.orderTag = (pointsAmount = 0) => {
    if (pointsAmount) {
      return 'spurit-loyalty-points-' + pointsAmount;
    } else {
      return 'spurit-loyalty-points';
    }
  };
};
